package com.wintermar.inspection.core.ui.component.image.util

import kotlinx.serialization.KSerializer
import kotlinx.serialization.Serializable
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

object ByteArrayBase64Serializer : KSerializer<ByteArray> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("ByteArrayBase64", PrimitiveKind.STRING)

    @OptIn(ExperimentalEncodingApi::class)
    override fun serialize(encoder: Encoder, value: ByteArray) {
        encoder.encodeString(Base64.encode(value))
    }

    @OptIn(ExperimentalEncodingApi::class)
    override fun deserialize(decoder: Decoder): ByteArray {
        return Base64.decode(decoder.decodeString())
    }
}

@Serializable
data class FileChunkModel(
    val id: String = "",
    val fileId: String = "",
    val fileName: String = "",
    val originalFileName: String = "",
    val chunkNumber: Int = 0,
    val chunkSize: Int = 0,
    val fileSize: Int = 0,
    val totalFiles: Int = 0,
    @Serializable(with = ByteArrayBase64Serializer::class)
    val blob: ByteArray? = null
) {
    //generated when declare byte array
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as FileChunkModel

        if (chunkNumber != other.chunkNumber) return false
        if (chunkSize != other.chunkSize) return false
        if (fileSize != other.fileSize) return false
        if (totalFiles != other.totalFiles) return false
        if (id != other.id) return false
        if (fileId != other.fileId) return false
        if (fileName != other.fileName) return false
        if (originalFileName != other.originalFileName) return false
        if (!blob.contentEquals(other.blob)) return false

        return true
    }

    //generated when declare byte array
    override fun hashCode(): Int {
        var result = chunkNumber
        result = 31 * result + chunkSize
        result = 31 * result + fileSize
        result = 31 * result + totalFiles
        result = 31 * result + id.hashCode()
        result = 31 * result + fileId.hashCode()
        result = 31 * result + fileName.hashCode()
        result = 31 * result + originalFileName.hashCode()
        result = 31 * result + (blob?.contentHashCode() ?: 0)
        return result
    }
}
